<template>
    <div class="nav">
        <ul class="flex bg-[#2B2C32] rounded-full px-8 py-1">
            
            <li class="mr-4">
                <router-link :class="'text-white text-sm' + ($route.name == 'LocationIntegrationPayment' ? ' active' : '')" :to="{ name: 'LocationIntegrationPayment'}">PAYMENTS</router-link>
            </li>
            <li class="mr-4">
                <router-link  :class="'text-white text-sm uppercase' + ($route.name == 'LocationIntegrationsCrm' ? ' active' : '')" :to="{ name: 'LocationIntegrationsCrm'}">CRM </router-link>
            </li>
            <!-- <li class="mr-4">
                <router-link  :class="'text-white text-sm' + ($route.name == 'LocationIntegrationAccessToken' ? ' active' : '')" :to="{ name: 'LocationIntegrationAccessToken'}">
                    ACCESS TOKENS
                </router-link>
            </li> -->

            <li class="mr-4" v-if="can_manage_compliance_settings">
                <router-link  :class="'text-white text-sm' + ($route.name == 'LocationComplianceSettings' ? ' active' : '')" :to="{ name: 'LocationComplianceSettings'}">
                    COMPLIANCE
                </router-link>
            </li>
            <li class="mr-4">
                <router-link  :class="'text-white text-sm uppercase' + ($route.name == 'Marketplace' ? ' active' : '')" :to="{ name: 'Marketplace'}">Marketplace </router-link>
            </li>
        </ul>
    </div>
</template>

  
<script lang="ts">
import  { defineComponent } from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import Helpers from '@/helpers';

export default defineComponent({
  name: "LocationIntegrationNav",

  setup() {
    
    return  {
      
    };
  },

 
  computed: {
    /** Check for permissions */
    can_manage_compliance_settings() {
        return Helpers.getMyPermission('can_manage_compliance_settings');
    },
  },

  async mounted() {
   
  },

  methods: {

    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })

  }
});
</script>


<style scoped>
    .active:before {
        content: '';
        position: absolute;
        background: #1A5A40;
        width: 100%;
        height: 4px;
        bottom: -8px;
    }
    .nav ul li{
        position:relative;
    }

</style>